import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

export const httpFetchMerchants = () => {
  return get("admin/merchants");
};

export const httpMerchantLimit = (userID: string) => {
  return get(`admin/merchants/limit/${encodeParam(userID)}`);
};

export const httpMerchantTransactionAnalytics = (
  id: string,
  date: Date | string,
) => {
  return get(
    `admin/merchants/transactionAnalytics/${encodeParam(id)}?date=${encodeParam(date)}`,
  );
};

export const httpMerchantTransactions = (
  id: string,
  type: string,
  limit: number,
  page: number,
) => {
  return get(
    `admin/merchants/transactions/${encodeParam(id)}?type=${encodeParam(type)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};

export const httpUSearchMerchant = (userName: string, signal?: AbortSignal) => {
  return get(`admin/merchants/search?search=${encodeParam(userName)}`, signal);
};
